<template>
  <el-container>
    <el-header>
      <common-header :enable-to-login="false"/>
    </el-header>
    <el-main class="maincontainer">
      <div class="login-title">
        <div class="t1">{{ $t('lang.loginPage.ceibsStudentCert') }}</div>
      </div>
      <div>
        <el-row style="margin-left: 0; margin-right: 0; margin-top: 44px;">
          <el-col :span="isLogin ? 8 : 10" :offset="12">
            <login-card v-if="isLogin"></login-card>
            <not-login-card v-else></not-login-card>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { mapGetters } from 'vuex'
import { find } from '@/api/apply'
import NotLoginCard from '@/views/login/component/NotLoginCard'
import LoginCard from '@/views/login/component/LoginCard'
import { getAccessToken, getRefreshToken } from '@/util/util.ruquest'

export default {
  name: 'login',
  components: { LoginCard, NotLoginCard, CommonHeader },
  computed: {
    ...mapGetters([
      'currentApplyId'
    ]),
    isLogin: function () {
      return getAccessToken() && getRefreshToken()
    }
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('ceibs-login')
    this.loadIfApplyIdExists()
  },
  destroyed () {
    document.getElementsByTagName('body')[0].classList.remove('ceibs-login')
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    loadIfApplyIdExists () {
      if (this.currentApplyId) {
        find({
          id: this.currentApplyId
        }).then(res => {
          const applyVo = res.data
          if (applyVo.applyStatus === 'DRAFT') {
            this.$confirm(this.$t('lang.loginPage.youHaveUnFinishedApply'), this.$t('lang.common.warning'), {
              type: 'warning',
              confirmButtonClass: 'el-button--ceibsprimary',
              cancelButtonClass: 'el-button--ceibs'
            }).then(() => {
              if (!applyVo.packVoList) {
                // 无包装信息，去确认个人信息
                this.goto('confirmInfo')
              } else {
                // 有包装信息，去装袋页
                this.goto('confirmPack')
              }
            }, () => {
              this.$store.dispatch('removeCurrentApplyId')
            })
          } else {
            this.$store.dispatch('removeCurrentApplyId')
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.login-title {
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
  margin-top: 50px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.login-title .t1 {
  font-size: 42px;
  text-shadow: 2px 2px 5px rgb(136 136 136 / 25%);
}

.box-card {
  background-color: unset;
  border-radius: 8px;
  border: none;
  box-shadow: 3px 7px 12px 1px rgb(0 0 0 / 45%);
}

/deep/ .el-card__header {
  padding: 0;
}

/deep/ .el-card__body {
  background-color: rgba(255, 255, 255, 0.85);
  /*height: 160px;*/
}

/deep/ .el-col {
  padding-bottom: 30px;
}

.notice {
  text-align: left;
  color: #565656;
}

.notice-title {
  font-weight: bold;
  font-size: 18px;
}

.notice-content {
  margin-top: 0;
  font-size: 14px;
  height: 75px;
  display: block;
  overflow-y: auto;
}

</style>
